import { Component, OnInit, AfterViewInit, Renderer, ElementRef, ViewChild } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { JhiLanguageService } from 'ng-jhipster';

import { Register } from './register.service';
import { Captcha } from './captcha.model';

import {SafeUrl, DomSanitizer} from '@angular/platform-browser';

@Component({
    selector: 'jhi-register',
    templateUrl: './register.component.html'
})
export class RegisterComponent implements OnInit, AfterViewInit {

    confirmPassword: string;
    doNotMatch: string;
    error: string;
    errorEmailExists: string;
    errorInvalidCaptcha: string;
    registerAccount: any;
    success: boolean;
    modalRef: NgbModalRef;
    captcha: Captcha;
    audioUrl: SafeUrl;
    isAudioVisible: boolean;
    isAudioPlaying: boolean;

    @ViewChild('audioplayer') audioplayer;

    constructor(
        private languageService: JhiLanguageService,
        private registerService: Register,
        private elementRef: ElementRef,
        private renderer: Renderer,
        private sanitizer: DomSanitizer
    ) {
    }

    ngOnInit() {
        this.success = false;
        this.isAudioVisible = false;
        this.isAudioPlaying = false;
        this.registerAccount = {};
        this.updateCaptcha();
    }

    ngAfterViewInit() {
        this.renderer.invokeElementMethod(this.elementRef.nativeElement.querySelector('#email'), 'focus', []);
    }
    updateCaptcha() {
        this.registerService.getCaptcha()
                     .subscribe(
                       captcha => {
                           this.captcha = captcha;
                           this.audioUrl = this.sanitizer.bypassSecurityTrustUrl(`data:audio/wav;base64,${captcha.audioValue}`);
                           this.registerAccount.captchaExpectedHashedAnswer = this.captcha.answerHashedValue;
                           this.registerAccount.audioCaptchaExpectedHashedAnswer = this.captcha.audioanswerHashedValue;
                       });
    }



    register(formValid: boolean) {
        if (formValid) {
            if (this.registerAccount.password !== this.confirmPassword) {
                this.doNotMatch = 'ERROR';
            } else {
                this.doNotMatch = null;
                this.error = null;
                this.errorEmailExists = null;
                this.errorInvalidCaptcha = null;
                this.languageService.getCurrent().then(key => {
                    this.registerAccount.langKey = key;
                    this.registerService.save(this.registerAccount).subscribe(() => {
                        this.success = true;
                    }, (response) => this.processError(response));
                });
            }
        }
    }

    private processError(response) {
        this.success = null;
        if (response.status === 400 && response._body === 'e-mail address already in use') {
            this.errorEmailExists = 'ERROR';
        } else if (response.status === 400 && response._body === 'invalid captcha') {
            this.errorInvalidCaptcha = 'ERROR';
            this.updateCaptcha();
        } else {
            this.error = 'ERROR';
        }
    }

    showAudio() {
        this.isAudioVisible = true;
    }
    playPauseAudio() {
        if (this.isAudioPlaying) {
            this.isAudioPlaying = false;
            this.audioplayer.nativeElement.pause();
        } else {
            this.isAudioPlaying = true;
            this.audioplayer.nativeElement.play();
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/register/register.component.ts